import styled from '@emotion/styled';
import { SerializedStyles, css } from '@emotion/react';
import { statusLabel } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

interface StatusWrapperType {
    status: 'live' | 'scheduled' | 'ended' | 'info',
}

const buildStatusWrapper = (status: 'live' | 'scheduled' | 'ended' | 'info'): SerializedStyles => {
    if (status === 'live') {
        return css`
            color: ${statusLabel.live.txtColor};
            background: ${statusLabel.live.bgColor};
        `;
    }

    if (status === 'scheduled') {
        return css`
            color: ${statusLabel.scheduled.txtColor};
            background: ${statusLabel.scheduled.bgColor};
        `;
    }

    if (status === 'ended') {
        return css`
            color: ${statusLabel.ended.txtColor};
            background: ${statusLabel.ended.bgColor};
        `;
    }

    return css`
        color: ${statusLabel.info.txtColor};
        background: ${statusLabel.info.bgColor};
    `;
};

export const StatusWrapper = styled('div', { label: 'StatusWrapper' })<StatusWrapperType>`
    ${({ status }): SerializedStyles => buildStatusWrapper(status)};
    border-radius: 4px;
    font-size: ${fontSize.xSmall};
    font-weight: ${fontWeight.medium};
    height: 22px;
    line-height: 1.3334;
    min-width: 68px;
    padding: 4px 8px;
    text-align: center;

    &:first-letter {
        text-transform: uppercase;
    }
`;
